import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ubi-cell-top-bar-action-events',
    templateUrl: './top-bar-action-events.component.html',
    styleUrls: ['./top-bar-action-events.component.scss'],
    standalone: false
})
export class TopBarActionEventsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
